(function () {
    'use strict';

    angular.module("imApp").factory("timeCustomersService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1290,
                    parameters: parms || {}
                });
            },
            listTimeCustomers: function (parms) {
                return $ihttp.post({
                    method: 52,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
